var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useTimeoutWhen } from 'rooks';
import LoadRemote from './LoadRemote';
var ScheduledLoadRemote = function (_a) {
    var _b = _a.scheduleAfter, scheduleAfter = _b === void 0 ? 0 : _b, props = __rest(_a, ["scheduleAfter"]);
    var _c = __read(useState(true), 2), shouldWait = _c[0], setShouldWait = _c[1];
    useTimeoutWhen(function () { return setShouldWait(false); }, scheduleAfter);
    if (shouldWait)
        return _jsx(_Fragment, {}, void 0);
    return _jsx(LoadRemote, __assign({}, props), void 0);
};
export default memo(ScheduledLoadRemote);
//# sourceMappingURL=ScheduledLoadRemote.js.map